import { useEffect } from "react";

export function setListBackground() {
  setTimeout(() => {
    document.querySelector("html")?.classList.add("html--list");
  }, 15);
}

export function unsetListBackground() {
  document.querySelector("html")?.classList.remove("html--list");
}

export function useListBackground() {
  useEffect(() => {
    setListBackground();

    return () => {
      unsetListBackground();
    };
  }, []);
}
